import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { saveAs } from 'file-saver';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import LeadsContext from '@/modules/leads/contexts/LeadsContext';
import Button from '@/modules/common/components/Button';
import ButtonGroup from '@/modules/common/components/ButtonGroup';
import DownloadMenu from '@/modules/common/components/DownloadMenu';
import TextHelpField from '@/modules/common/components/TextHelpField';
import ContentBodyTop from '@/modules/common/components/ContentBodyTop';
import { withFetch } from '~/hocs/fetch';
import { withRouter } from '~/hocs/router';
import { base64toBlob } from '~/common';
import { actionSetDownloadingLeads } from '@/modules/application/actions/downloading';
import TitleAdmin from './TitleAdmin';
import TitleAffiliate from './TitleAffiliate';

const Top = (props) => {
    const leadsContext = useContext(LeadsContext);

    const fetch = (format) => {
        props.setFetching(true);
        return props.fetch.get(`/api/leads/download/${format}/?${props.router.urlSearchParams.toString()}`)
            .then(({ok, data}) => {
                if (ok) {
                    const blob = base64toBlob(data.blob);
                    // noinspection JSUnresolvedVariable
                    saveAs(blob, data.file_name);
                }
            })
            .finally(() => {
                props.setFetching(false);
            });
    };

    const handleClickDownload = (popupState, format) => () => {
        popupState.close();
        fetch(format);
    };

    return (
        <ContentBodyTop
            left={<>
                {(props.leads.length > 0)
                    ? <DownloadMenu fetching={props.fetching} onClickDownload={handleClickDownload}/>
                    : null
                }
            </>}
            center={<>
                {(!props.user.affiliate)
                    ? <TitleAdmin/>
                    : <TitleAffiliate/>
                }
            </>}
            right={
                <form id="form-filter" onSubmit={props.onSubmitFilter}>
                    <TextHelpField label="Список ID"
                                   value={leadsContext.valuesFilter.ids}
                                   onChange={
                                       (event) => leadsContext.setValuesFilter({
                                           ...leadsContext.valuesFilter,
                                           ids: event.target.value,
                                       })
                                   }
                    >
                        ID должны быть разделены пробелом
                    </TextHelpField>
                    <ButtonGroup>
                        {(leadsContext.isFiltered())
                            ? <Button onClick={props.onClickResetFilter}>Очистить фильтр</Button>
                            : null
                        }
                        <Button type="submit">Применить фильтр</Button>
                    </ButtonGroup>
                </form>
            }
        />
    );
};

// noinspection DuplicatedCode
Top.propTypes = {
    leads: PropTypes.array.isRequired,
    onClickResetFilter: PropTypes.func.isRequired,
    onSubmitFilter: PropTypes.func.isRequired,
};

let Component = Top;
Component = withRouter(Component);
Component = withFetch(Component);

export default connect(
    (state) => ({
        user: state.auth.user,
        fetching: state.downloading.leads,
    }),
    (dispatch) => ({
        setFetching: bindActionCreators(actionSetDownloadingLeads, dispatch),
    })
)(Component);
